var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .115v2.539H6.546c-.53 0-.889.115-1.074.346-.185.23-.278.577-.278 1.038v1.818h2.713l-.36 2.846H5.193V16H2.361V8.702H0V5.856h2.361V3.76c0-1.193.321-2.117.963-2.774C3.966.329 4.821 0 5.89 0 6.796 0 7.5.038 8 .115z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d9fc95a30b4880d382adf22878d1713e.svg";
export { ForwardRef as ReactComponent };